import axios from "axios";
import createAxiosInstance from "../../utils/axiosInstance";

export const getActivities = async (payload) => {
    try {
      const axiosInstance = createAxiosInstance(payload.accessToken);
      const response      = await axiosInstance.get(`/activity/${payload.userId}?timezone=${payload.userTimeZone}`);
      return response.data;
    } catch(err) {
      console.log(err);
    }
}

export const getApprenticeshipActivities = async (userUuid, products, token) => {
  try {
    let api_url;

    products.forEach(value => {
      if(value.sp_slug === "eportfolio") {
        api_url = value.api_url;
      }
    });

    if(api_url === undefined) {
      return [];
    }else {
      
      if(!token) {
        return [];
      }

      const apiToken = token;

      let myportfolioConfig = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${api_url}api/v1/get/learner/${userUuid}/activities-logs`,
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${apiToken}`,
        },
        data: {
          user_uuid: userUuid,
        },
      };
      const activities = await axios.request(myportfolioConfig);

      return activities?.data?.data?.activities;

    }

  }catch(err) {
    console.log(err,'error while fetching portfolio activities');
  }
}